module.exports = __webpack_public_path__ + "img/graph.9b89e2c1.png";